import React, { Component } from 'react';
import { connect } from 'react-redux';
import { selectedOption } from '../../../actions/stepTwo';
import './searchableSelect.scss';
import { Input } from '../../../component';
import { SearchIcon, LocationIcon, AirplaneIcon } from '~svg';
class SearchableSelect extends Component {
  state = {
    inputFocused: false,
    resultHovered: false,
    value: '',
  };

  componentDidMount() {
    if (this.props.defaultValue)
      this.setState({ value: this.props.defaultValue });
  }
  componentDidUpdate(prevProps) {
    if (prevProps?.isReset !== this.props?.isReset) {
      this.setState({ value: '' });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.defaultValue !== nextProps.defaultValue)
      this.setState({ value: nextProps.defaultValue });
  }
  render() {
    const direction =
        this.props.language.direction === 'ltr' ? 'right' : 'left',
      themeMode = this.props.themeMode ? this.props.themeMode : 'light';
    const {
      isOutSideLabel = true,
      py,
      boxColor,
      labelPosition,
      id,
      customPlaceHolderClass,
    } = this.props;
    return (
      <div className={`position-relative ${this.props.containerClass}`}>
        <div className="position-relative col-12 d-flex p-0 h-100 align-items-center">
          <div
            aria-hidden="true"
            style={{
              position: 'absolute',
              zIndex: 2,
              top: isOutSideLabel ? '52%' : '',

              [direction]: '0.6rem',
              // transform: "translate(-50%,-50%)",
            }}
          >
            <SearchIcon
              color="#aaacaf"
              variant="svg-md-small svg-sm-small svg-xs-small svg-tiny "
            />
          </div>

          <Input
            autoComplete="off"
            id={id}
            className={this.props.inputClass}
            inputClassName={this.props.inputClassname}
            label={this.props.placeholder}
            onFocus={() => this.setState({ inputFocused: true })}
            onBlur={() => this.setState({ inputFocused: false })}
            value={this.state.value}
            error={this.props.error}
            onChange={(event) => {
              let value = event.target.value;
              this.setState({ value });
              this.props.search(event);
            }}
            name={this.props.name}
            type="text"
            themeMode={themeMode}
            iconUrl={null}
            outSideLabelClass={`text-start font-small`}
            labelColor={this.props.labelColor}
            outSideLabelPosition="top"
            outSideLabel={isOutSideLabel}
            heightSize={this.props.heightSize}
            boxColor={`${
              this.state.inputFocused
                ? `border-radius-bottom-0 ${boxColor ?? 'bg-third-light'}`
                : `${boxColor ?? 'bg-third-light'}`
            }`}
            py={py}
            labelPosition={labelPosition}
            customPlaceHolderClass={customPlaceHolderClass}
          />
        </div>
        {this.renderSearchResult()}
      </div>
    );
  }
  renderSearchResult = () => {
    const themeMode = this.props.themeMode ? this.props.themeMode : 'light';
    if (
      this.props?.list?.length &&
      (this.state.inputFocused || this.state.resultHovered)
    )
      return (
        <div
          className={`position-absolute border-items ${
            themeMode === 'dark'
              ? 'bg-primary border-third'
              : `${this.props.listClass}`
          } `}
          style={{
            top: '88%',
            // left: "2%",
            zIndex: 200,
            maxHeight: 400,
            overflow: 'auto',
            width: '100%',
            ...this.props.popupStyle,
          }}
          onMouseEnter={() => this.setState({ resultHovered: true })}
          onMouseLeave={() => this.setState({ resultHovered: false })}
        >
          {this.props?.list && this.props?.list?.map(this.renderResult)}
        </div>
      );
  };

  renderResult = (item, index) => {
    const { name, children } = this.props;
    let themeMode = this.props.themeMode ? this.props.themeMode : 'light';
    if (children && typeof children == 'function')
      return (
        <div className="" key={index} onClick={this.select.bind(this, item)}>
          {children(item, index)}
        </div>
      );
    if (this.props.type && this.props.type === 'location')
      return (
        <div className="font-small" key={index}>
          <div
            className="pl-1 border-bottom searchHover py-3"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              this.select(
                {
                  ...item,
                  currentTarget: {
                    name,
                    value: `${item.countryName.en}, ${item.locationName.en}`,
                  },
                },
                true,
              )
            }
          >
            <span className="px-2 text-secondary">
              <LocationIcon size={20} color="#00798c" />
            </span>
            {item.countryName.en}, {item.locationName.en}
            <span className="font-smaller">(All Airports)</span>
          </div>
          {item.airports && item.airports.length ? (
            item.airports.map((airport, index) => {
              return (
                <div
                  key={index}
                  className={`pl-3 py-3 border-bottom  searchHover`}
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    this.select(
                      {
                        ...airport,
                        currentTarget: {
                          name,
                          value: `${airport.iata}, ${airport.name.en}`,
                        },
                      },
                      true,
                    )
                  }
                >
                  <span className="px-2 text-secondary">
                    <AirplaneIcon size={20} color="#00798c" />
                    {airport.iata}, {airport.name.en}
                  </span>
                </div>
              );
            })
          ) : (
            <div className="pl-2 py-4 border-bottom">NO OPTION FOUND</div>
          )}
        </div>
      );
    else
      return (
        <div
          key={index}
          className={`p-2 ${
            themeMode === 'dark' ? 'darksearchHover ' : ' search-rows '
          } border-bottom d-flex`}
          style={{ cursor: 'pointer' }}
          onClick={() =>
            this.select({
              ...item,
              currentTarget: {
                name,
                value: this.resolve(item, this.props.display),
              },
            })
          }
        >
          {this.resolve(item, this.props.display)}
        </div>
      );
  };

  resolve(cur, ns, location) {
    if (location && cur.name && cur.name.en) {
      return cur.name.en;
    } else if (
      location &&
      cur.countryName &&
      cur.countryName.en &&
      cur.locationName &&
      cur.locationName.en
    ) {
      cur.name = { en: cur.countryName.en + ', ' + cur.locationName.en };
      return cur.name.en;
    } else if (
      location &&
      cur.airports &&
      cur.airports.length &&
      cur.airports[0].name.en
    ) {
      return cur.airports[0].name.en;
    } else {
      let undef;
      ns = ns.split('.');
      while (cur && ns[0]) cur = cur[ns.shift()] || undef;
      return cur;
    }
  }
  select = (item) => {
    this.setState({ resultHovered: false });
    this.props.selectedOption(item);
    this.props.select(item);
  };
}

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectedOption: (item) => {
      dispatch(selectedOption(item));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SearchableSelect);
